const translation = {
  currentPlan: '當前套餐',
  upgradeBtn: {
    plain: '升級套餐',
    encourage: '立即升級',
    encourageShort: '升級',
  },
  viewBilling: '管理賬單及訂閱',
  buyPermissionDeniedTip: '請聯絡企業管理員訂閱',
  plansCommon: {
    title: '選擇適合您的套餐',
    yearlyTip: '訂閱年度計劃可免費獲得 2個月！',
    mostPopular: '最受歡迎',
    planRange: {
      monthly: '按月',
      yearly: '按年',
    },
    month: '月',
    year: '年',
    save: '節省',
    currentPlan: '當前計劃',
    contractSales: '聯絡銷售',
    contractOwner: '聯絡團隊管理員',
    free: '免費',
    startForFree: '免費開始',
    getStartedWith: '開始使用',
    contactSales: '聯絡銷售',
    talkToSales: '聯絡銷售',
    modelProviders: '支援的模型提供商',
    teamMembers: '團隊成員',
    buildApps: '構建應用程式數',
    vectorSpace: '向量空間',
    vectorSpaceTooltip: '向量空間是 LLMs 理解您的資料所需的長期記憶系統。',
    vectorSpaceBillingTooltip: '向量儲存是將知識庫向量化處理後為讓 LLMs 理解資料而使用的長期記憶儲存，1MB 大約能滿足1.2 million character 的向量化後資料儲存（以 OpenAI Embedding 模型估算，不同模型計算方式有差異）。在向量化過程中，實際的壓縮或尺寸減小取決於內容的複雜性和冗餘性。',
    documentsUploadQuota: '文件上傳配額',
    documentProcessingPriority: '文件處理優先順序',
    documentProcessingPriorityTip: '如需更高的文件處理優先順序，請升級您的套餐',
    documentProcessingPriorityUpgrade: '以更快的速度、更高的精度處理更多的資料。',
    priority: {
      'standard': '標準',
      'priority': '優先',
      'top-priority': '最高優先順序',
    },
    logsHistory: '日誌歷史',
    customTools: '自定義工具',
    unavailable: '不可用',
    days: '天',
    unlimited: '無限制',
    support: '支援',
    supportItems: {
      communityForums: '社群論壇',
      emailSupport: '電子郵件支援',
      priorityEmail: '優先電子郵件和聊天支援',
      logoChange: 'Logo更改',
      SSOAuthentication: 'SSO 認證',
      personalizedSupport: '個性化支援',
      dedicatedAPISupport: '專用 API 支援',
      customIntegration: '自定義整合和支援',
      ragAPIRequest: 'RAG API 請求',
      bulkUpload: '批次上傳文件',
      agentMode: '代理模式',
      workflow: '工作流',
    },
    comingSoon: '即將推出',
    member: '成員',
    memberAfter: '個成員',
    messageRequest: {
      title: '訊息額度',
      tooltip: '為不同方案提供基於 OpenAI 模型的訊息響應額度。',
    },
    annotatedResponse: {
      title: '標註回覆數',
      tooltip: '標註回覆功能透過人工編輯標註為應用提供了可定製的高質量問答回覆能力',
    },
    ragAPIRequestTooltip: '指單獨呼叫 Dify 知識庫資料處理能力的 API。',
    receiptInfo: '只有團隊所有者和團隊管理員才能訂閱和檢視賬單資訊',
  },
  plans: {
    sandbox: {
      name: 'Sandbox',
      description: '200次 GPT 免費試用',
      includesTitle: '包括：',
    },
    professional: {
      name: 'Professional',
      description: '讓個人和小團隊能夠以經濟實惠的方式釋放更多能力。',
      includesTitle: 'Sandbox 計劃中的一切，加上：',
    },
    team: {
      name: 'Team',
      description: '協作無限制並享受頂級效能。',
      includesTitle: 'Professional 計劃中的一切，加上：',
    },
    enterprise: {
      name: 'Enterprise',
      description: '獲得大規模關鍵任務系統的完整功能和支援。',
      includesTitle: 'Team 計劃中的一切，加上：',
    },
  },
  vectorSpace: {
    fullTip: '向量空間已滿。',
    fullSolution: '升級您的套餐以獲得更多空間。',
  },
  apps: {
    fullTipLine1: '升級您的套餐以',
    fullTipLine2: '構建更多的程式。',
  },
  annotatedResponse: {
    fullTipLine1: '升級您的套餐以',
    fullTipLine2: '標註更多對話。',
    quotaTitle: '標註的配額',
  },
  monthlyBillOverview: {
    title: '月度賬單概覽',
    monthSelector: '賬單月份：',
    overview: '月度概覽',
    overviewTitle: '月概覽',
    billingCycle: '賬單週期：',
    to: '至',
    status: {
      billed: '已出賬',
      pending: '出賬中',
    },
    exportBill: '導出賬單',
    exportSuccess: '導出成功',
    exportError: '導出失敗，請稍後重試',
    payableAmount: '應付金額',
    tabs: {
      accountSummary: '按資源購買賬號匯總',
      productSummary: '按產品匯總',
    },
    table: {
      resourcePurchaseAccount: '資源購買賬號',
      billingPeriod: '賬務賬期',
      catalogTotalPrice: '目錄總價（原價）',
      discountedPrice: '折後價',
      voucherDeduction: '代金券抵扣',
      payableAmount: '應付金額',
      productType: '產品類型',
      billingMode: '計費模式',
      feeType: '費用類型',
      prepaid: '預付費',
      postpaid: '後付費',
    },
  },
  monthlyBillHistory: {
    title: '月度賬單歷史',
    billingPeriod: '賬務賬期：',
    resourcePurchaseAccount: '資源購買賬號：',
    dateRangePlaceholder: {
      startMonth: '開始月份',
      endMonth: '結束月份',
    },
    maxQueryWarning: '最多查詢12個月的數據',
    table: {
      resourcePurchaseAccount: '資源購買賬號',
      billingPeriod: '賬務賬期',
      catalogTotalPrice: '目錄總價（原價）',
      discountedPrice: '折後價',
      voucherDeduction: '代金券抵扣',
      payableAmount: '應付金額',
      status: '狀態',
      action: '操作',
      detail: '詳情',
    },
    status: {
      billed: '已出賬',
      pending: '出賬中',
    },
    pagination: {
      total: '共 {total} 條',
    },
  },
  accountSelector: {
    placeholder: '請選擇資源購買賬號',
    all: '全部',
  },
  invoice: {
    title: '發票管理',
    alert: {
      description1: '發票申請提交後，我們將在5個工作日內完成開票並發送至您的郵箱。',
      description2: '僅支持對已出賬的賬單開具發票。',
      description3: '發票金額為實際支付金額，不包含代金券抵扣部分。',
      description4: '如需修改發票信息，請聯絡客服處理。',
    },
    tabs: {
      issue: '開具發票',
      history: '開票歷史',
      headers: '發票抬頭',
      email: '接收方式',
    },
    history: {
      table: {
        applyTime: '申請時間 (UTC+8)',
        title: '發票抬頭',
        invoiceType: '發票類型',
        medium: '發票介質',
        invoiceNumber: '發票號碼',
        amount: '發票金額',
        comment: '備註',
        status: '狀態',
        action: '操作',
        detail: '詳情',
      },
      status: {
        processing: '開票中',
        completed: '已開票',
        failed: '開票失敗',
      },
      pagination: {
        total: '共{{total}}條記錄',
      },
    },
    issueInvoice: {
      table: {
        month: '開票月份',
        documentName: '單據名稱',
        totalAmount: '發票總額',
      },
      pagination: {
        total: '共{{total}}個',
      },
      selected: '已選擇 {{count}} 項，總金額：¥ {{amount}}',
      nextStep: '下一步',
    },
    invoicing: {
      title: '申請發票',
      steps: {
        selectItems: '選擇開票條目',
        confirmInfo: '確認發票信息',
        complete: '完成',
      },
      customerKeyInfo: '客戶關鍵信息',
      customerBasicInfo: '客戶基本信息',
      manageTitle: '發票抬頭信息管理',
      selectOtherEmail: '選擇其他郵箱',
      previous: '上一步',
      submit: '提交',
      fields: {
        title: '發票抬頭',
        issueType: '開具類型',
        invoiceType: '發票類型',
        amount: '開票金額',
        medium: '發票介質',
        digitalInvoice: '數碼發票',
        digitalInvoiceTooltip: '數字化電子發票（簡稱"數電發票"）：是"全面數字化的電子發票"的簡稱，不以紙質形式存在，是與紙質發票具有同等法律效力的全新發票',
        receiveInfo: '接收信息',
        receiveInfoDescription: '請選擇發票中需要展示的稅務信息，選中後將展示在發票備註欄中的稅務信息，',
        addressPhone: '購買方地址，電話',
        bankAccount: '購買方開戶銀行，銀行賬號',
        comment: '備註',
        commentPlaceholder: '如有需要，請填入',
        commentWarning: '此處填寫的備註信息將在發票中顯示內容區',
      },
      modals: {
        selectEmail: {
          title: '選擇電子郵箱',
        },
        cancel: '取消',
        confirm: '確定',
      },
      messages: {
        emailRequired: '請選擇郵箱',
        titleRequired: '請選擇發票抬頭',
        applySuccess: '申請成功',
      },
    },
    historyDetail: {
      title: '發票詳情',
      fields: {
        title: '發票抬頭',
        issueType: '開具類型',
        invoiceType: '發票類型',
        normalInvoice: '普通發票',
        vatInvoice: '增值稅發票',
        amount: '開票金額',
        taxRate: '稅額',
        taxRateValue: '6%',
        medium: '發票介質',
        comment: '備註',
        applyTime: '申請時間',
        taxInfo: '稅務信息',
      },
    },
    headers: {
      title: '發票抬頭',
      editInfo: '修改發票信息',
      noHeader: '暫無生效中的發票抬頭，請點擊',
      management: '發票抬頭管理',
      toSetup: '進行設置',
      fields: {
        issueType: '開具類型',
        company: '企業',
        personal: '個人',
        title: '發票抬頭',
        invoiceType: '發票類型',
        normalVAT: '增值稅普通發票',
        specialVAT: '增值稅專用發票',
        taxNumber: '納稅人識別號',
        bankName: '開戶銀行名稱',
        bankAccount: '開戶銀行賬號',
        address: '註冊場所地址',
        phone: '註冊固定電話',
        realName: '真實姓名',
        idNumber: '身份證號',
      },
    },
    titleForm: {
      title: '發票信息',
      tooltips: {
        normalVAT: '增值稅普通發票：開票對象不具備一般納稅人資質，發票不能用於進項稅抵扣。',
        specialVAT: '增值稅專用發票：開票對象需具備一般納稅人資質，可以進行進項稅抵扣。',
      },
      rules: {
        titleRequired: '請輸入發票抬頭',
        taxNumberRequired: '請輸入納稅人識別號',
        realNameRequired: '請輸入真實姓名',
        idNumberRequired: '請輸入身份證號',
      },
      placeholders: {
        title: '請輸入發票抬頭',
        taxNumber: '請輸入納稅人識別號',
        bankName: '請輸入開戶銀行名稱',
        bankAccount: '請輸入開戶銀行賬號',
        address: '請輸入註冊詳細地址',
        phone: '請輸入註冊座機電話',
        realName: '請輸入真實姓名',
        idNumber: '請輸入身份證號',
      },
      buttons: {
        cancel: '取消',
        confirm: '確定',
      },
      messages: {
        updateSuccess: '發票信息更新成功',
      },
    },
    email: {
      title: '電子郵箱',
      addEmail: '添加電子郵箱',
      maxLimit: '您最多可添加50個電子郵箱',
      table: {
        email: '電子郵箱',
        defaultEmail: '默認郵箱',
        action: '操作',
        setDefault: '設為默認',
        edit: '修改',
        delete: '刪除',
      },
      messages: {
        setDefaultSuccess: '設置默認郵箱成功',
        setDefaultFailed: '設置默認郵箱失敗',
        addSuccess: '添加郵箱成功',
        addFailed: '添加郵箱失敗',
        editSuccess: '修改郵箱成功',
        editFailed: '修改郵箱失敗',
        deleteSuccess: '刪除郵箱成功',
        deleteFailed: '刪除郵箱失敗',
      },
      modals: {
        addTitle: '添加電子郵箱',
        editTitle: '修改電子郵箱',
        deleteTitle: '信息提示',
        emailLabel: '電子郵箱',
        emailRequired: '請輸入電子郵箱',
        emailInvalid: '請輸入有效的郵箱地址',
        emailPlaceholder: '請輸入郵箱地址',
        isDefault: '是否默認',
        cancel: '取消',
        confirm: '確定',
        confirmDelete: '確定刪除',
        deleteConfirm: '確認要刪除以下電子郵箱嗎？',
      },
    },
    adminInvoiceDetail: {
      title: '發票管理/發票詳情',
      detailTitle: '開票明細',
      exportButton: '導出明細',
      fields: {
        title: '發票抬頭',
        issueType: '開具類型',
        invoiceType: '發票類型',
        normalInvoice: '普通發票',
        vatInvoice: '增值稅發票',
        amount: '開票金額',
        taxRate: '稅額',
        taxRateValue: '6%',
        medium: '發票介質',
        onlineInvoice: '數電發票',
        paperInvoice: '紙質發票',
        comment: '備註',
        applyTime: '申請時間',
        taxInfo: '稅務信息',
      },
      table: {
        servicePeriod: '服務賬期',
        productName: '產品名稱',
        productType: '產品類型',
        consumeTime: '消費時間 (UTC+8)',
        tradeTime: '交易時間 (UTC+8)',
        orderId: '訂單號',
        billKind: '賬單類型',
        amount: '可開票金額',
      },
      pagination: {
        total: '共 {{total}} 條',
      },
      messages: {
        fetchDetailError: '獲取發票詳情失敗',
        fetchListError: '獲取發票明細失敗',
        exportSuccess: '導出成功',
        exportError: '導出失敗，請稍後重試',
      },
    },
    adminInvoiceManagement: {
      title: '發票管理',
      alert: {
        description1: '管理員在收到用戶的開票申請時，請核對相關信息，信息無誤後給用戶開票。',
        description2: '管理員在完成【實際開票→發送郵件】後，可點擊【開票】操作，填寫發票號碼，標記【已開票】。',
        description3: '如信息有誤請填寫原因後進行【拒絕】操作。',
        description4: '所有申請需在 72 小時內 處理完畢【含開票/拒絕】',
      },
      filters: {
        category: '開具類型',
        invoiceType: '發票類型',
        status: '發票狀態',
        placeholder: '請選擇',
      },
      table: {
        applyTime: '申請時間 (UTC+8)',
        title: '發票抬頭',
        category: '開具類型',
        invoiceType: '發票類型',
        medium: '發票介質',
        amount: '開票金額',
        status: '狀態',
        operator: '操作人',
        operateTime: '操作時間',
        action: '操作',
        detail: '詳情',
        approve: '開票',
        reject: '拒絕',
      },
      status: {
        processing: '待開票',
        completed: '已開票',
        failed: '開票失敗',
      },
      pagination: {
        total: '共{{total}}條記錄',
      },
      modals: {
        confirm: '確定',
        cancel: '取消',
        approve: {
          title: '開票操作',
          invoiceNumber: '發票號碼',
          invoiceNumberRequired: '請輸入發票號碼',
          invoiceNumberPlaceholder: '請填寫',
        },
        reject: {
          title: '拒絕開票',
          rejectReason: '拒絕原因:',
          rejectReasonRequired: '請輸入拒絕原因',
          rejectReasonPlaceholder: '請填寫拒絕原因',
        },
      },
      messages: {
        approveSuccess: '開票操作成功',
        approveError: '開票操作失敗',
        rejectSuccess: '拒絕操作成功',
        rejectError: '拒絕操作失敗',
      },
    },
  },
  billCycle: {
    title: '賬單週期',
    alert: {
      description1: '當月數據查詢結果僅供參考，不作為對賬依據；當月最終賬單在次月2日12點後支持查看/導出。',
      description2: '已出賬的賬單支持開發票。',
    },
    tabs: {
      orderDetail: '訂單出賬明細',
      billDetail: '賬單明細',
    },
  },
}

export default translation
